import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';
import {
  CarInformation,
  ModelTypeLookupResponse,
  BrandLookupResponse,
  DriveModeLookupResponse,
  ModelLookupResponse,
} from '@/features/HsnTsn/types';

export class VehicleDataHttpService extends HttpService {
  getByHsnTsn(hsn: string, tsn: string): HttpClientResponse<CarInformation> {
    return this.httpClient.get(`vehicle-data?hsn=${hsn}&tsn=${tsn}`);
  }

  getBrands(): HttpClientResponse<BrandLookupResponse> {
    return this.httpClient.get('vehicle-data/hersteller');
  }

  getModelTypes(brand: string): HttpClientResponse<ModelTypeLookupResponse> {
    return this.httpClient.get(`vehicle-data/klassen?hersteller=${brand}`);
  }

  getDriveModes(
    brand: string,
    modelType: string,
  ): HttpClientResponse<DriveModeLookupResponse> {
    return this.httpClient.get(
      `vehicle-data/antriebsarten-and-leistungen?hersteller=${brand}&klasse=${modelType}`,
    );
  }

  getModels(
    brand: string,
    modelType: string,
    driveMode: string,
    powerMin: number,
    powerMax: number,
  ): HttpClientResponse<ModelLookupResponse> {
    return this.httpClient.get(
      `vehicle-data/vehicles?hersteller=${brand}&klasse=${modelType}&antriebsart=${driveMode}&leistungMin=${powerMin}&leistungMax=${powerMax}`,
    );
  }
}
